import { gql } from 'graphql-tag';

export const markConsentGivenAt = gql`
  mutation markConsentGivenAt($id: String) {
    markConsentGivenAt(id: $id)
  }
`;
